module.exports = __webpack_public_path__ + "img/fail.71426fd9.png";